import Image from 'next/image';

import '@/styles/globals.css';
import '@/styles/globals.v2.css';

import LogoImage from '@/assets/images/logo.svg';
import SadDogImage from '@/assets/images/SadPug.jpg';
import { HeadingThree } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';

import NotFoundButton from './NotFoundButton';

const NotFound = () => {
  return (
    <div className="mx-auto flex h-[100vh] justify-center">
      <div className="grid flex-col justify-between justify-items-center pt-[30px] sm:px-4 md:px-0">
        <Image src={LogoImage} alt="Logo" width={209} height={65} />
        <div className="v2-flex-col v2-flex max-w-[521px] gap-[30px] text-center">
          <HeadingThree variant="dark" className="v2-text-2xl v2-font-bold font-sweet-sans-pro-bold">
            Uh-oh! We Hit a Roadblock.
          </HeadingThree>
          <Paragraph className="text-black">
            It seems like there was an issue with the request you made. No worries! Double-check the URL or try
            refreshing the page. Need more help? Our support team is here for you!
          </Paragraph>
          <NotFoundButton className="v2-rounded-xs v2-text-sm v2-w-fit v2-font-sweet-sans-pro-medium v2-mx-auto v2-px-[14px] v2-py-DEFAULT">
            Keep Shopping
          </NotFoundButton>
        </div>

        <Image src={SadDogImage} alt="Sad Pug" width={575} height={355} />

        <p className="v2-fixed v2-text-base v2-text-black v2-font-sweet-sans-pro bottom-[30px] sm:right-4 md:right-[186px]">
          Error Code: PT1
        </p>
      </div>
    </div>

    // Server Bumping
    // <div className="mx-auto flex h-[100vh] justify-center">
    //   <div className="flex flex-col items-center justify-between pt-[30px] sm:px-4 md:px-0">
    //     <Image src={LogoImage} alt="Logo" width={209} height={65} />
    //     <div className="v2-flex-col v2-flex max-w-[521px] gap-[30px] text-center">
    //       <HeadingThree variant="dark" className="font-sweet-sans-pro-bold v2-text-2xl v2-font-bold">
    //         We’re Sorry for the Hiccups!
    //       </HeadingThree>
    //       <Paragraph className="text-black">
    //         Our website is currently experiencing some internal server issues. We understand the inconvenience and are
    //         working quickly to get things sorted out. Please try again later.
    //       </Paragraph>
    //       <NotFoundButton className="v2-rounded-xs v2-text-sm v2-w-fit v2-font-sweet-sans-pro-medium v2-mx-auto v2-px-[14px] v2-py-DEFAULT">
    //         Go to Homepage
    //       </NotFoundButton>
    //     </div>

    //     <Image src={ServerBumpImage} alt="Sad Pug" height={229} />

    //     <p className="v2-fixed v2-text-base v2-text-black v2-font-sweet-sans-pro sm:bottom-[144px] sm:right-4 md:bottom-[55px] md:right-[186px]">
    //       Error Code: PT1
    //     </p>
    //   </div>
    // </div>

    // Intentional Maintenance
    // <div className="mx-auto flex h-[100vh] justify-center">
    //   <div className="flex flex-col items-center justify-between pt-[30px] sm:px-4 sm:pb-[187px] md:px-0 md:pb-[118px] xs:pb-[36%]">
    //     <Image src={LogoImage} alt="Logo" width={209} height={65} />

    //     <div className="v2-flex-col v2-flex max-w-[564px] gap-[30px] text-center">
    //       <Image src={MaintenanceImage} alt="Maintenance Image" width={564} height={376} />
    //       <HeadingThree variant="dark" className="font-sweet-sans-pro-bold v2-text-2xl v2-font-bold">
    //         Be Right Back!
    //       </HeadingThree>
    //       <Paragraph className="mx-auto max-w-[418px] text-black">
    //         Our website is getting a quick makeover and will be back, better than ever, shortly! Thank you for your
    //         patience and understanding.
    //       </Paragraph>
    //     </div>
    //   </div>
    // </div>
  );
};

export default NotFound;
